(function () {
  function initNotesTranslations() {
    if (document.querySelector('.notes-common [data-lang="es"]')) return;

    var labels = {
      es: {
        nozzle: 'Temperatura de boquilla',
        bed: 'Temperatura de cama',
        platform: 'Cama recomendada',
        adhesive: 'Adhesivo',
        best: 'Ideal para',
        storage: 'Almacenamiento',
        drying: 'Secado',
        notes: 'Notas:',
        storageValue: 'Evite temperaturas y humedad elevadas; selle con desecante.',
        dryingValue: 'Seque a 50 °C durante 6-8 h; no use directamente un horno de alta temperatura.',
        tableHeaders: ['Parámetro', 'Valor']
      },
      pt: {
        nozzle: 'Temperatura do bico',
        bed: 'Temperatura da mesa',
        platform: 'Mesa recomendada',
        adhesive: 'Adesivo',
        best: 'Ideal para',
        storage: 'Armazenamento',
        drying: 'Secagem',
        notes: 'Observações:',
        storageValue: 'Evite temperatura e humidade elevadas; mantenha selado com dessecante.',
        dryingValue: 'Seque a 50 °C durante 6-8 h; não use diretamente um forno de alta temperatura.',
        tableHeaders: ['Parâmetro', 'Valor']
      }
    };

    function material(language, title, nozzle, bed, platform, adhesive, best, notes) {
      var label = labels[language];
      return {
        title: title,
        rows: [
          [label.nozzle, nozzle],
          [label.bed, bed],
          [label.platform, platform],
          [label.adhesive, adhesive],
          [label.best, best],
          [label.storage, label.storageValue],
          [label.drying, label.dryingValue]
        ],
        notes: notes
      };
    }

    var materials = {
      es: {
        pla: material('es', 'Parámetros de uso de PLA', '190-220 °C; recomendado: 200-210 °C', 'Abierta: 50-60 °C; cerrada: 45-60 °C', 'Cama de vidrio, cama PEI', 'Pegamento sólido, adhesivo en aerosol', 'Principiantes, modelos cotidianos, decoraciones y prototipos', [
          'Puede imprimirse a temperatura ambiente; evite las corrientes de aire frío.',
          'Selle el filamento después de abrirlo; la humedad causa hilos, burbujas y una superficie rugosa.',
          'Si la adhesión es deficiente, limpie primero la plataforma y aplique una pequeña cantidad de adhesivo.'
        ]),
        'pla-bio': material('es', 'Parámetros de uso de PLA+ Bio', '190-230 °C; óptimo: 220 °C', 'Abierta: 60 °C; cerrada: 45-60 °C', 'Cama de vidrio, cama PEI', 'Pegamento sólido, adhesivo en aerosol', 'Principiantes, modelos cotidianos, decoraciones y prototipos', [
          'Puede imprimirse a temperatura ambiente; evite las corrientes de aire frío.',
          'Selle el filamento después de abrirlo; la humedad causa hilos, burbujas y una superficie rugosa.',
          'Si la adhesión es deficiente, limpie primero la plataforma y aplique una pequeña cantidad de adhesivo.'
        ]),
        'pla-silk': material('es', 'Parámetros de uso de PLA Silk', '195-220 °C', 'Abierta: 60 °C; cerrada: 45-60 °C', 'Cama de vidrio, cama PEI', 'Pegamento sólido, adhesivo en aerosol', 'Artículos decorativos, piezas de exhibición, regalos y modelos artísticos', [
          'Reduzca ligeramente la velocidad de impresión para mejorar el brillo y la uniformidad de las capas.',
          'El material Silk es sensible a la temperatura y a la velocidad; pruebe primero con piezas pequeñas.',
          'Después de un almacenamiento prolongado, selle bien el filamento para evitar burbujas o subextrusión.'
        ]),
        petg: material('es', 'Parámetros de uso de PETG', '230-260 °C', 'Abierta: 70-80 °C; cerrada: 70-80 °C', 'Cama PEI', 'Pegamento sólido, adhesivo en aerosol', 'Piezas funcionales, piezas duraderas, componentes estructurales y modelos transparentes o semitransparentes', [
          'PETG tiene buena tenacidad, pero puede generar hilos; optimice la retracción.',
          'Mantenga el filamento seco; la humedad puede causar burbujas y superficies rugosas.',
          'Reduzca adecuadamente la velocidad del ventilador para mejorar la adhesión entre capas.'
        ]),
        'pla-matte': material('es', 'Parámetros de uso de PLA Matte', '190-220 °C; recomendado: 205-215 °C', 'Abierta: 50-60 °C; cerrada: 45-60 °C', 'Cama de vidrio, cama PEI', 'Pegamento sólido, adhesivo en aerosol', 'Impresión de modelos, piezas de exhibición, figuras, prototipos de diseño y piezas estéticas', [
          'Adecuado para imprimir a temperatura ambiente; evite corrientes frías para prevenir deformaciones.',
          'Selle después de abrir; la humedad genera hilos, burbujas, superficie rugosa y pérdida del acabado mate.',
          'Si la adhesión es deficiente, limpie primero la plataforma y aplique una pequeña cantidad de adhesivo.',
          'Para un mejor acabado mate, evite temperaturas de impresión excesivamente altas y ajuste según el modelo.'
        ]),
        'pla-metallic': material('es', 'Parámetros de uso de PLA Metallic', '190-230 °C; recomendado: 205-215 °C', 'Abierta: 50-60 °C; cerrada: 45-60 °C', 'Cama de vidrio, cama PEI', 'Pegamento sólido, adhesivo en aerosol', 'Modelos de exhibición, figuras, decoraciones artísticas, piezas decorativas y prototipos de diseño', [
          'Puede imprimirse a temperatura ambiente; evite las corrientes de aire frío.',
          'Selle después de abrir; la humedad genera hilos, burbujas, superficie rugosa y pérdida del efecto metálico.',
          'Si la adhesión es deficiente, limpie primero la plataforma y aplique una pequeña cantidad de adhesivo.',
          'Para un mejor efecto metálico, evite temperaturas de impresión excesivamente altas y ajuste según el modelo.'
        ]),
        'pla-chameleon': material('es', 'Parámetros de uso de PLA Galaxy', '190-230 °C; recomendado: 205-215 °C', 'Abierta: 50-60 °C; cerrada: 45-60 °C', 'Cama de vidrio, cama PEI', 'Pegamento sólido, adhesivo en aerosol', 'Modelos artísticos, figuras, decoraciones de exhibición, piezas decorativas y trabajos creativos', [
          'Puede imprimirse a temperatura ambiente; evite las corrientes de aire frío.',
          'Selle después de abrir; la humedad genera hilos, burbujas, superficie rugosa y pérdida del efecto nacarado.',
          'Si la adhesión es deficiente, limpie primero la plataforma y aplique una pequeña cantidad de adhesivo.',
          'Para un mejor efecto nacarado, evite temperaturas de impresión excesivamente altas y ajuste según el modelo.'
        ]),
        abs: material('es', 'Parámetros de uso de ABS', '230-260 °C; abierta: 240 °C; cerrada: 260 °C', 'Cerrada: 90-100 °C', 'Cama PEI', 'Pegamento sólido, adhesivo en aerosol', 'Piezas funcionales, carcasas y piezas para lijado o pintura posterior', [
          'Utilice una impresora cerrada para reducir deformaciones y grietas.',
          'Mantenga estable la temperatura ambiente durante la impresión y evite corrientes de aire frío.',
          'Reduzca o apague el ventilador y ajuste según la estructura del modelo y el equipo.'
        ]),
        tpu: material('es', 'Parámetros de uso de TPU', '230-250 °C; óptimo: 230 °C', 'Abierta: 60 °C; cerrada: 45-60 °C', 'Cama PEI', 'Pegamento sólido, adhesivo en aerosol', 'Piezas flexibles, piezas antideslizantes, piezas amortiguadoras y fundas protectoras', [
          'TPU es flexible; reduzca la velocidad de impresión para evitar el deslizamiento del filamento.',
          'Las impresoras con extrusor remoto son más difíciles de usar; se recomienda un extrusor directo.',
          'Mantenga una trayectoria de filamento suave y reduzca al mínimo curvas y resistencia.'
        ]),
        'petg-cf': material('es', 'Parámetros de uso de PETG-CF', '230-260 °C; recomendado: 245-255 °C', 'Abierta: 70-80 °C; cerrada: 70-80 °C', 'Cama PEI', 'Pegamento sólido, adhesivo en aerosol', 'Piezas estructurales, piezas funcionales, modelos industriales, componentes mecánicos y carcasas', [
          'PETG-CF contiene refuerzo de fibra de carbono; use una boquilla resistente al desgaste, como acero endurecido.',
          'Selle después de abrir; la humedad causa hilos, burbujas, extrusión inestable y mala adhesión entre capas.',
          'Si la adhesión es deficiente, limpie primero la plataforma y aplique una pequeña cantidad de adhesivo.'
        ])
      },
      pt: {
        pla: material('pt', 'Parâmetros de utilização do PLA', '190-220 °C; recomendado: 200-210 °C', 'Aberta: 50-60 °C; fechada: 45-60 °C', 'Mesa de vidro, mesa PEI', 'Cola sólida, adesivo em spray', 'Iniciantes, modelos do dia a dia, decorações e protótipos', [
          'Pode ser impresso à temperatura ambiente; evite correntes de ar frio.',
          'Sele após abrir; a humidade causa fios, bolhas e acabamento de superfície áspero.',
          'Se a adesão for fraca, limpe primeiro a plataforma e aplique uma pequena quantidade de adesivo.'
        ]),
        'pla-bio': material('pt', 'Parâmetros de utilização do PLA+ Bio', '190-230 °C; ideal: 220 °C', 'Aberta: 60 °C; fechada: 45-60 °C', 'Mesa de vidro, mesa PEI', 'Cola sólida, adesivo em spray', 'Iniciantes, modelos do dia a dia, decorações e protótipos', [
          'Pode ser impresso à temperatura ambiente; evite correntes de ar frio.',
          'Sele após abrir; a humidade causa fios, bolhas e acabamento de superfície áspero.',
          'Se a adesão for fraca, limpe primeiro a plataforma e aplique uma pequena quantidade de adesivo.'
        ]),
        'pla-silk': material('pt', 'Parâmetros de utilização do PLA Silk', '195-220 °C', 'Aberta: 60 °C; fechada: 45-60 °C', 'Mesa de vidro, mesa PEI', 'Cola sólida, adesivo em spray', 'Peças decorativas, peças de exposição, presentes e modelos artísticos', [
          'Reduza ligeiramente a velocidade de impressão para melhorar o brilho e a uniformidade das camadas.',
          'O material Silk é sensível à temperatura e à velocidade; teste primeiro com peças pequenas.',
          'Após armazenamento prolongado, sele bem o filamento para evitar bolhas ou subextrusão.'
        ]),
        petg: material('pt', 'Parâmetros de utilização do PETG', '230-260 °C', 'Aberta: 70-80 °C; fechada: 70-80 °C', 'Mesa PEI', 'Cola sólida, adesivo em spray', 'Peças funcionais, peças duráveis, componentes estruturais e modelos transparentes ou semitransparentes', [
          'O PETG tem boa tenacidade, mas tende a criar fios; otimize a retração.',
          'Mantenha o filamento seco; a humidade pode causar bolhas e superfícies ásperas.',
          'Reduza adequadamente a velocidade da ventoinha para melhorar a adesão entre camadas.'
        ]),
        'pla-matte': material('pt', 'Parâmetros de utilização do PLA Matte', '190-220 °C; recomendado: 205-215 °C', 'Aberta: 50-60 °C; fechada: 45-60 °C', 'Mesa de vidro, mesa PEI', 'Cola sólida, adesivo em spray', 'Impressão de modelos, peças de exposição, figuras, protótipos de design e peças estéticas', [
          'Adequado para impressão à temperatura ambiente; evite correntes frias para prevenir deformações.',
          'Sele após abrir; a humidade causa fios, bolhas, superfície áspera e perda do efeito mate.',
          'Se a adesão for fraca, limpe primeiro a plataforma e aplique uma pequena quantidade de adesivo.',
          'Para obter o melhor efeito mate, evite temperaturas de impressão excessivamente altas e ajuste conforme o modelo.'
        ]),
        'pla-metallic': material('pt', 'Parâmetros de utilização do PLA Metallic', '190-230 °C; recomendado: 205-215 °C', 'Aberta: 50-60 °C; fechada: 45-60 °C', 'Mesa de vidro, mesa PEI', 'Cola sólida, adesivo em spray', 'Modelos de exposição, figuras, decorações artísticas, peças decorativas e protótipos de design', [
          'Pode ser impresso à temperatura ambiente; evite correntes de ar frio.',
          'Sele após abrir; a humidade causa fios, bolhas, superfície áspera e perda do efeito metálico.',
          'Se a adesão for fraca, limpe primeiro a plataforma e aplique uma pequena quantidade de adesivo.',
          'Para obter o melhor efeito metálico, evite temperaturas de impressão excessivamente altas e ajuste conforme o modelo.'
        ]),
        'pla-chameleon': material('pt', 'Parâmetros de utilização do PLA Galaxy', '190-230 °C; recomendado: 205-215 °C', 'Aberta: 50-60 °C; fechada: 45-60 °C', 'Mesa de vidro, mesa PEI', 'Cola sólida, adesivo em spray', 'Modelos artísticos, figuras, decorações de exposição, peças decorativas e trabalhos criativos', [
          'Pode ser impresso à temperatura ambiente; evite correntes de ar frio.',
          'Sele após abrir; a humidade causa fios, bolhas, superfície áspera e perda do efeito perolado.',
          'Se a adesão for fraca, limpe primeiro a plataforma e aplique uma pequena quantidade de adesivo.',
          'Para obter o melhor efeito perolado, evite temperaturas de impressão excessivamente altas e ajuste conforme o modelo.'
        ]),
        abs: material('pt', 'Parâmetros de utilização do ABS', '230-260 °C; aberta: 240 °C; fechada: 260 °C', 'Fechada: 90-100 °C', 'Mesa PEI', 'Cola sólida, adesivo em spray', 'Peças funcionais, carcaças e peças para lixamento ou pintura posterior', [
          'Utilize um ambiente de impressão fechado para reduzir deformações e fissuras.',
          'Mantenha a temperatura ambiente estável durante a impressão e evite correntes de ar frio.',
          'Reduza ou desligue a ventoinha e ajuste conforme a estrutura do modelo e o equipamento.'
        ]),
        tpu: material('pt', 'Parâmetros de utilização do TPU', '230-250 °C; ideal: 230 °C', 'Aberta: 60 °C; fechada: 45-60 °C', 'Mesa PEI', 'Cola sólida, adesivo em spray', 'Peças flexíveis, peças antiderrapantes, peças de amortecimento e capas protetoras', [
          'TPU é um material flexível; reduza a velocidade de impressão para evitar o escorregamento do filamento.',
          'Impressoras com extrusor remoto são mais difíceis; dê prioridade a extrusores de acionamento direto.',
          'Garanta um percurso suave do filamento e reduza curvas e resistência ao mínimo.'
        ]),
        'petg-cf': material('pt', 'Parâmetros de utilização do PETG-CF', '230-260 °C; recomendado: 245-255 °C', 'Aberta: 70-80 °C; fechada: 70-80 °C', 'Mesa PEI', 'Cola sólida, adesivo em spray', 'Peças estruturais, peças funcionais, modelos industriais, componentes mecânicos e carcaças', [
          'PETG-CF contém reforço de fibra de carbono; utilize um bico resistente ao desgaste, como aço endurecido.',
          'Sele após abrir; a humidade causa fios, bolhas, extrusão instável e fraca adesão entre camadas.',
          'Se a adesão for fraca, limpe primeiro a plataforma e aplique uma pequena quantidade de adesivo.'
        ])
      }
    };

    var common = {
      es: {
        title: 'Guía de uso de filamentos CaiLab para impresión 3D',
        usageTitle: 'I. Instrucciones de uso',
        storageTitle: '1. Apertura y almacenamiento',
        storage: ['Selle el filamento inmediatamente después de abrirlo.', 'Guárdelo en una bolsa sellada con desecante si no se utilizará durante un período prolongado.', 'Evite entornos de alta temperatura y humedad.'],
        moistureTitle: 'La humedad puede causar:',
        moisture: ['Más hilos', 'Extrusión inestable', 'Burbujas en la superficie', 'Acabado superficial rugoso', 'Mala adhesión entre capas'],
        prePrintTitle: '2. Comprobación antes de imprimir',
        prePrint: ['Confirme que la boquilla esté limpia y sin obstrucciones.', 'Mantenga limpia la plataforma de impresión.', 'Seleccione los parámetros de impresión según el tipo de material.', 'Haga una prueba de primera capa antes de iniciar la impresión completa.'],
        adhesionTitle: '3. Recomendaciones de adhesión a la cama',
        adhesionHeaders: ['Tipo de plataforma', 'Recomendación'],
        adhesionRows: [['Lámina de acero PEI', 'Normalmente no se necesita adhesivo; aplique pegamento si es necesario.'], ['Cama de vidrio', 'Se recomienda usar pegamento sólido para una mejor adhesión.'], ['Otras plataformas', 'Ajuste según los resultados reales de impresión.']],
        issueTitle: '4. Solución de problemas frecuentes',
        issueHeaders: ['Problema', 'Ajuste recomendado'],
        issueRows: [['Hilos', 'Baje la temperatura de la boquilla y aumente la retracción.'], ['Obstrucción', 'Revise la humedad y reduzca la velocidad de impresión.'], ['Deformación', 'Aumente la temperatura de la cama y mejore el cerramiento.'], ['Superficie rugosa', 'Revise el secado y la temperatura.'], ['Mala adhesión entre capas', 'Aumente la temperatura de la boquilla.']],
        presetTitle: 'II. Guía de parámetros preestablecidos',
        download: 'Enlace de descarga: Haz clic para descargar'
      },
      pt: {
        title: 'Guia de utilização de filamentos CaiLab para impressão 3D',
        usageTitle: 'I. Instruções de utilização',
        storageTitle: '1. Abertura e armazenamento',
        storage: ['Sele o filamento imediatamente após abrir.', 'Guarde-o num saco selado com dessecante quando não for utilizado durante períodos prolongados.', 'Evite ambientes de temperatura e humidade elevadas.'],
        moistureTitle: 'A humidade pode causar:',
        moisture: ['Mais fios', 'Extrusão instável', 'Bolhas na superfície', 'Acabamento superficial áspero', 'Fraca adesão entre camadas'],
        prePrintTitle: '2. Verificação antes de imprimir',
        prePrint: ['Confirme que o bico está limpo e sem entupimentos.', 'Mantenha a plataforma de impressão limpa.', 'Selecione os parâmetros de impressão de acordo com o tipo de material.', 'Faça um teste da primeira camada antes de iniciar a impressão completa.'],
        adhesionTitle: '3. Recomendações de adesão à mesa',
        adhesionHeaders: ['Tipo de plataforma', 'Recomendação'],
        adhesionRows: [['Chapa de aço PEI', 'Normalmente não é necessário adesivo; aplique cola se necessário.'], ['Mesa de vidro', 'Recomenda-se cola sólida para melhorar a adesão.'], ['Outras plataformas', 'Ajuste de acordo com os resultados reais de impressão.']],
        issueTitle: '4. Resolução de problemas comuns',
        issueHeaders: ['Problema', 'Ajuste sugerido'],
        issueRows: [['Fios', 'Reduza a temperatura do bico e aumente a retração.'], ['Entupimento', 'Verifique a humidade e reduza a velocidade de impressão.'], ['Deformação', 'Aumente a temperatura da mesa e melhore o encerramento.'], ['Superfície áspera', 'Verifique o estado de secagem e a temperatura.'], ['Fraca adesão entre camadas', 'Aumente a temperatura do bico.']],
        presetTitle: 'II. Guia de parâmetros predefinidos',
        download: 'Link de descarga: Clique para descarregar'
      }
    };

    function appendText(parent, tagName, text) {
      var node = document.createElement(tagName);
      node.textContent = text;
      parent.appendChild(node);
      return node;
    }

    function appendList(parent, items) {
      var list = document.createElement('ul');
      items.forEach(function (item) {
        appendText(list, 'li', item);
      });
      parent.appendChild(list);
    }

    function appendTable(parent, headers, rows) {
      var table = document.createElement('table');
      table.className = 'notes-table';
      var header = document.createElement('tr');
      headers.forEach(function (item) {
        appendText(header, 'th', item);
      });
      table.appendChild(header);
      rows.forEach(function (row) {
        var tableRow = document.createElement('tr');
        row.forEach(function (item) {
          appendText(tableRow, 'td', item);
        });
        table.appendChild(tableRow);
      });
      parent.appendChild(table);
    }

    function appendCommon(language, data) {
      var host = document.querySelector('.notes-common');
      if (!host) return;
      var panel = document.createElement('div');
      panel.setAttribute('data-lang', language);
      panel.style.display = 'none';
      appendText(panel, 'h1', data.title);
      appendText(panel, 'h2', data.usageTitle);
      appendText(panel, 'h3', data.storageTitle);
      appendList(panel, data.storage);
      appendText(panel, 'p', data.moistureTitle);
      appendList(panel, data.moisture);
      appendText(panel, 'h3', data.prePrintTitle);
      appendList(panel, data.prePrint);
      appendText(panel, 'h3', data.adhesionTitle);
      appendTable(panel, data.adhesionHeaders, data.adhesionRows);
      appendText(panel, 'h3', data.issueTitle);
      appendTable(panel, data.issueHeaders, data.issueRows);
      appendText(panel, 'h2', data.presetTitle);
      var downloads = document.createElement('ul');
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = 'https://drive.weixin.qq.com/s?k=AMQAEwfmAFEFDHc6qB';
      link.textContent = data.download;
      item.appendChild(link);
      downloads.appendChild(item);
      panel.appendChild(downloads);
      host.appendChild(panel);
    }

    function appendMaterial(language, tab, data) {
      var host = document.querySelector('.notes-material[data-tab="' + tab + '"]');
      if (!host) return;
      var panel = document.createElement('div');
      panel.setAttribute('data-lang', language);
      panel.style.display = 'none';
      appendText(panel, 'h2', data.title);
      appendTable(panel, labels[language].tableHeaders, data.rows);
      appendText(panel, 'h3', labels[language].notes);
      appendList(panel, data.notes);
      host.appendChild(panel);
    }

    Object.keys(common).forEach(function (language) {
      appendCommon(language, common[language]);
      Object.keys(materials[language]).forEach(function (tab) {
        appendMaterial(language, tab, materials[language][tab]);
      });
    });

    var languageSelect = document.getElementById('notesLangSelect');
    if (languageSelect) {
      languageSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNotesTranslations);
  } else {
    initNotesTranslations();
  }
})();
